import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
export var createEmptyTooltipIcon = function () {
    return React.createElement(EventCardIcon, { className: "rj-ev-list__ev-card-icon--tooltip rj-ev-list__ev-card-icon--empty rj-ev-list__ev-card-icon--hidden-on-mobile" },
        React.createElement(Icon, { i: "i-24-16" }));
};
//# sourceMappingURL=createEmptyTooltipIcon.js.map